import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
    'navBar.lang': '语言',
    'layout.user.link.help': '帮助',
    'layout.user.link.privacy': '隐私',
    'layout.user.link.terms': '条款',
    'app.preview.down.block': '下载此页面到本地项目',
    'app.welcome.link.fetch-blocks': '获取全部区块',
    'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
    ...pages,
    ...globalHeader,
    ...menu,
    ...settingDrawer,
    ...settings,
    ...pwa,
    ...component,
    // --- Api 对外接口相关 ---
    'api.error.INVALID_APP_KEY': '无效的 AppKey',
    'api.error.APP_KEY_REQUIRED': '请提供 AppKey',
    'api.error.USER_DISABLED': '您的账号已被禁用，请联系客服',
    'api.error.INTERNAL_SERVER_ERROR': '服务器内部错误，请稍后再试',
    'api.error.USER_FROZEN': '账号已被冻结，请联系管理员',

    // --- 公共登录相关 ---
    'api.error.CAPTCHA_INCORRECT': '验证码不正确',
    'api.error.CAPTCHA_GENERATE_FAILED': '验证码生成失败',
    'api.error.LOGIN_PARAMS_ABNORMAL': '登录参数异常',
    'api.error.TOKEN_VERIFY_FAILED': '登录已过期，请重新登录',
    'api.error.TOKEN_INVALID': '无效的身份令牌',
    'api.error.TOKEN_SIGNATURE_INVALID': '身份签名校验失败',
    'api.error.TOKEN_MISSING': '未检测到登录状态',
    'api.error.INVALID_CREDENTIALS': '用户名或密码错误',
    'api.error.TOKEN_GENERATION_FAILED': '登录令牌生成失败',

    // --- 账户状态相关 ---
    'api.error.ACCOUNT_NAME_REQUIRED': '账户名不能为空',
    'api.error.BANK_CARD_NO_REQUIRED': '银行卡号不能为空',
    'api.error.ACCOUNT_LIST_FETCH_FAILED': '查询账户列表失败',
    'api.error.INVALID_USER_ID': '无效的用户 ID',
    'api.error.USER_NOT_FOUND': '未找到相关用户信息',
    'api.error.USER_UPDATE_FAILED': '用户信息更新失败',
    'api.error.USER_CREATE_FAILED': '商户信息创建失败',
    'api.error.ACCOUNT_DISABLED': '该账户已被禁用',
    'api.error.ACCOUNT_LOCKED': '账户已被锁定',
    'api.error.DELETE_USER_FAILED': '注销账户失败',
    'api.error.USER_HAS_REMAINING_BALANCE': '账户内仍有余额，无法执行此操作',
    'api.error.USER_FETCH_FAILED': '获取用户信息失败',

    // --- 提现与交易业务 ---
    'api.error.UNSUPPORTED_WITHDRAW_METHOD': '不支持的提现方式',
    'api.error.INVALID_WITHDRAW_AMOUNT': '提现金额必须大于 0',
    'api.error.INVALID_PAY_PASSWORD': '支付密码错误',
    'api.error.PAY_PASSWORD_NOT_SET': '您尚未设置支付密码',
    'api.error.WITHDRAW_STATUS_DENY': '当前账户状态异常，无法发起提现',
    'api.error.INSUFFICIENT_BALANCE': '账户可用余额不足',
    'api.error.CREATE_WITHDRAW_RECORD_FAILED': '创建提现记录失败',
    'api.error.UPDATE_USER_BALANCE_FAILED': '扣减账户余额失败',
    'api.error.WRITE_FUND_LOG_FAILED': '资金流水写入失败',

    // --- 统计与报表 ---
    'api.error.USER_DAILY_STATS_GET_TODAY_FAILED': '获取今日统计数据失败',
    'api.error.USER_DAILY_STATS_TODAY_DATA_NOT_FOUND': '今日暂无统计数据',
    'api.error.ORDER_LIST_QUERY_FAILED': '查询订单数据失败',

    // --- 系统通知与公告 ---
    'api.error.UPDATE_NOTICE_FAILED': '更新阅读状态失败',
    'api.error.NOTIFICATION_COUNT_FAILED': '统计通知总数失败',
    'api.error.NOTIFICATION_QUERY_FAILED': '查询通知列表失败',

    // --- 商户提现账户管理 ---
    'api.error.USERACCOUNT_NO': '提现账户不存在',
    'api.error.USERACCOUNT_CREATE_FAILED': '创建提现账户失败',
    'api.error.USERACCOUNT_DELETE_FAILED': '删除提现账户失败',
    'api.error.USERACCOUNT_COUNT_FAILED': '统计提现账户数量失败',
    'api.error.USERACCOUNT_QUERY_FAILED': '查询提现账户列表失败',
    'api.error.USERACCOUNT_UPDATE_FAILED': '修改提现账户失败',
    'api.error.USERACCOUNT_PARAM_INVALID': '账户参数不合规',

    // --- 通用 ---
    'api.error.PARAMS_ABNORMAL': '请求参数异常',
};
